import gql from 'graphql-tag';

export default gql`
  mutation createChannel($channel: ChannelInput!) {
    createChannel(channel: $channel) {
      _id
    }
  }
`;
